import { GetterTree } from 'vuex';

export default <GetterTree<webparts.state.WebpartsState, RootState>>{};
